module.exports = __webpack_public_path__ + "img/page9img9.9721357a.png";